import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '@infodata-group/inf-commons';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  constructor(private _appConfig: AppConfig) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('assets') && request.url.endsWith('.json')) {
      return next.handle(
        request.clone({
          url: `${request.url}?v=${this._appConfig.appVersion}`,
        })
      );
    }
    return next.handle(request);
  }
}
